import { IJob, IRouterStore } from '@src/models';
import { ROUTES } from 'src/constants';
import { JOB_ACTION_TYPES } from '../constants';

export function getJobActionType(routerStore: IRouterStore) {
  if (routerStore.getMatch({ path: ROUTES.employer.jobs.new, exact: true })) {
    return JOB_ACTION_TYPES.CREATE_JOB;
  }
  if (routerStore.getMatch({ path: ROUTES.employer.jobs.clone, exact: true })) {
    return JOB_ACTION_TYPES.CLONE_JOB;
  }
  return JOB_ACTION_TYPES.EDIT_JOB;
}

export const getJobId = job => {
  return job.is_anonymous ? job.ability_token : job.id || job.ability_token;
};

export const formatJobToUnifiedShape = ({ company, ...job }: IJob) => {
  // original object could be frozen by feed store
  const formattedJob = {
    ...job,
    company: {
      size: job.company_size || company?.employees_count,
      cover_picture_url: company.cover_picture_url || company.cover,
      logo_url: company.logo_url || company.logo
    }
  } as { [key: string]: any };

  // if is anonymous job
  if (formattedJob.is_anonymous === true && !formattedJob.candidate_is_trusted) {
    formattedJob.company.motto = company.motto;
    formattedJob.company.industry = company.industry || formattedJob.company_industry;

    const officeCity = formattedJob.office_city || formattedJob.office?.city || '';
    const officeCountry = formattedJob.office_country || formattedJob.office?.country;

    formattedJob.office = {
      city: officeCity,
      country: officeCountry,
      address: [officeCity, officeCountry].filter(Boolean).join(', ')
    };
  } else {
    formattedJob.company = {
      ...formattedJob.company,
      ...company
    };
  }

  // ✅ Preserve external application data
  formattedJob.is_external = job.is_external ?? false;
  formattedJob.external_link = job.external_link ?? '';
  formattedJob.external_contact_info = job.external_contact_info ?? '';

  return formattedJob;
};
